import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../Helpers";
import {deserializeSurvey, Survey} from "../../Survey";

type NewComponentSurvey = Pick<ComponentSurvey, 'survey'>;

interface ComponentSurvey extends DeserializedRecord {
  survey: Survey
}

interface ComponentSurveyData extends JSONAPIRecord {
  relationships: {
    survey: JSONAPISingleRelationship
  }
}

const deserializeComponentSurvey: Deserializer<ComponentSurvey, ComponentSurveyData> = (data, included) => {
  const survey = deserializeSingleRelationship<Survey>(data.relationships.survey, included, deserializeSurvey);

  return {
    survey,
    ...deserializeItem(data)
  };
};

export {
  ComponentSurvey, deserializeComponentSurvey, NewComponentSurvey
};
